/** Una línea del archivo del banco, tal como va a quedar */
export class TransferenciaPreviaDto {
  public idPropietario!: number
  public propietario!: string
  public cbu!: string
  public alias!: string
  public importe!: number
  public cantidadLiquidaciones!: number
}

/** Un propietario o comprobante que queda afuera del archivo, y por qué */
export class ExclusionExportacionDto {
  public propietario!: string
  public motivo!: string
  public importe!: number
  public cantidadLiquidaciones!: number
  /** Corregible = falta cargar un dato. No corregible = es una decisión del contrato. */
  public esCorregible!: boolean
}

/**
 * Chequeo previo a exportar el archivo del banco.
 *
 * Separa bloqueantes de advertencias: los primeros impiden generar el archivo,
 * los segundos avisan que va a salir con menos de lo que el usuario tildó.
 */
export class ValidarExportacionBancoResponse {
  public puedeExportar: boolean = false
  public bloqueantes: string[] = []
  public advertencias: string[] = []

  public idBanco?: number | null
  public nombreBanco!: string
  public nombreTemplate!: string
  public nombreArchivo!: string

  public cuentaOrigen!: string
  public cbuOrigen!: string

  public cantidadTransferencias: number = 0
  public totalAExportar: number = 0
  public cantidadLiquidaciones: number = 0

  public transferencias: TransferenciaPreviaDto[] = []
  public excluidos: ExclusionExportacionDto[] = []
}
